// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface AsteriskIconSignature {
  Element: SVGSVGElement;
}

export const AsteriskIcon: TOC<AsteriskIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path d="M22 10.999H13.733L17.866 3.84L16.134 2.84L12 9.999L7.867 2.84L6.135 3.84L10.268 10.999H2V12.999H10.269L6.134 20.16L7.866 21.16L12 14L16.135 21.16L17.867 20.16L13.732 12.999H22V10.999Z"/>
</svg>
</template>;